import { writable, derived } from "svelte/store";
export const isCartActive = writable(false);
export const isCartLoading = writable(false);
export function toggleCart(val) {
    if (typeof val === "boolean") {
        if (val) {
            document.body.classList.add("has-active-offcanvas");
        }
        else {
            document.body.classList.remove("has-active-offcanvas");
        }
    }
    else {
        document.body.classList.toggle("has-active-offcanvas");
    }
    isCartActive.update((state) => (typeof val === "boolean" ? val : !state));
}
async function doFetch(callback) {
    isCartLoading.set(true);
    await callback();
    isCartLoading.set(false);
}
function isCart(maybeCart) {
    var _a;
    return Array.isArray((_a = maybeCart) === null || _a === void 0 ? void 0 : _a.items);
}
function createCart() {
    const { subscribe, set } = writable({
        items: [],
    });
    async function fetchCart() {
        await doFetch(async () => {
            const res = await fetch("/wp-json/farmcomp-store/cart");
            if (res.ok) {
                try {
                    const json = await res.json();
                    if (isCart(json)) {
                        set(json);
                    }
                }
                catch (e) {
                    console.error(e);
                }
            }
        });
    }
    async function setItemCount(id, quantity) {
        await doFetch(async () => {
            const params = new URLSearchParams();
            params.append("id", id);
            params.append("quantity", String(quantity));
            const res = await fetch(`/wp-json/farmcomp-store/cart/item?${params.toString()}`, {
                method: "POST",
            });
            if (res.ok) {
                try {
                    const json = await res.json();
                    if (isCart(json)) {
                        set(json);
                    }
                }
                catch (e) {
                    console.error(e);
                }
            }
        });
    }
    async function removeItem(id) {
        await doFetch(async () => {
            const params = new URLSearchParams();
            params.append("id", id);
            const res = await fetch(`/wp-json/farmcomp-store/cart/item?${params.toString()}`, {
                method: "DELETE",
            });
            if (res === null || res === void 0 ? void 0 : res.ok) {
                try {
                    const json = await res.json();
                    if (isCart(json)) {
                        set(json);
                    }
                }
                catch (e) {
                    console.error(e);
                }
            }
        });
    }
    return {
        subscribe,
        fetch: fetchCart,
        setItemCount,
        removeItem,
    };
}
const cart = createCart();
export default cart;
export const cartItemCount = derived(cart, ($cart) => $cart.items.reduce((acc, item) => {
    acc += item.quantity;
    return acc;
}, 0));
